export default "__VITE_PUBLIC_ASSET__c1fe18df__"